import { CategoryData } from '../../../../types/types';

export const famille = {
  'mwt': {
    translation: 'Mère',
    translationEn: 'Mother',
    illustration: '𓅐𓏏𓁐', // G14 (vautour) + X1 (t) + B1 (déterminatif femme)
    leadSign: 'G14',
    leadSignNote: 'G14 (vautour) est le hiéroglyphe même du mot « mère » : bamanan duga « vautour » ; maninka dùwa, mandinka duwa « vautour ».',
    reading: 'Lecture analytique — mwt (G14-X1-B1, tous signes confirmés), « mère ». G14 (vautour), le hiéroglyphe même du mot « mère », est le signe directeur ; X1 et B1 en sont le complément et le déterminatif féminin. Le même signe G14 sert aussi de déterminatif dans Nḫbt, « Nekhbet », la déesse-vautour protectrice de Haute-Égypte (voir la fiche « Nḫbt » dans Divinités, où il entre dans la graphie complète N35-Aa1-D58-X1-M22-X1-G14) : la mère et la déesse-vautour partagent ainsi, sans être le même mot, le même signe-image.',
    readingEn: 'Analytical reading — mwt (G14-X1-B1, all signs confirmed), "mother." G14 (vulture), the very hieroglyph for the word "mother," is the lead sign; X1 and B1 are its complement and the feminine determinative. The same sign G14 also serves as a determinative in Nḫbt, "Nekhbet," the vulture-goddess protector of Upper Egypt (see the "Nḫbt" entry in Divinities, where it appears in the full spelling N35-Aa1-D58-X1-M22-X1-G14): the mother and the vulture-goddess thus share, without being the same word, the same sign-image.'
  },
  'it': {
    translation: 'Père',
    translationEn: 'Father',
    illustration: '𓇋𓏏𓀀' // M17 (i) + X1 (t) + A1 (homme)
  },
  'sn ꜥꜣ': {
    translation: 'Frère aîné',
    translationEn: 'Elder brother',
    illustration: '𓈖𓏌𓀀a' // Correction : utilisation de T22 (sn) + O29 (ꜥꜣ) + A1
  },
  'sn dsr': {
    translation: 'Frère cadet / éloigné',
    translationEn: 'Younger / distant brother',
    illustration: '𓈖𓏌𓀀𓂋𓂡' // Graphie avec sn (T22) + ḏsr (D28/M29)
  },
  'snt ꜥꜣt': {
    translation: 'Sœur aînée',
    translationEn: 'Elder sister',
    illustration: '𓈖𓏌𓏏𓁐a𓏏' // sn + t + femme + ꜥꜣ + t
  },
  'sꜣw mwt': {
    translation: 'Grand-père (père de la mère) / Aïeul',
    translationEn: 'Grandfather (mother\'s father) / Ancestor',
    illustration: '𓇋𓏏𓈖𓅐' // Ajusté pour refléter le lien direct (it-mwt / sꜣ-mwt)
  },
  'sꜣw it': {
    translation: 'Grand-père (père du père)',
    translationEn: 'Grandfather (father\'s father)',
    illustration: '𓇋𓏏𓈖𓇋𓏏'
  },
  'sn it': {
    translation: 'Oncle (frère du père)',
    translationEn: 'Uncle (father\'s brother)',
    illustration: '𓈖𓏌𓀀𓇋𓏏' // sn (T22-N35-A1) + it (M17-X1)
  },
  'sn mwt': {
    translation: 'Oncle (frère de la mère)',
    translationEn: 'Uncle (mother\'s brother)',
    illustration: '𓈖𓏌𓀀𓅐' // sn + mwt
  },
  'snt it': {
    translation: 'Tante (sœur du père)',
    translationEn: 'Aunt (father\'s sister)',
    illustration: '𓈖𓏌𓏏𓁐𓇋𓏏' // snt + it
  },
  'snt mwt': {
    translation: 'Tante (sœur de la mère)',
    translationEn: 'Aunt (mother\'s sister)',
    illustration: '𓈖𓏌𓏏𓁐𓅐' // snt + mwt
  },
  'sꜣ sn': {
    translation: 'Cousin(e) (enfant du frère)',
    translationEn: 'Cousin (brother\'s child)',
    illustration: '𓅭𓈖𓏌' // sꜣ (G39/G38 - canard/oie) + sn
  },
  'ḥmt': {
    translation: 'Épouse',
    translationEn: 'Wife',
    illustration: '𓈞𓏏𓁐' // N41 (ḥmt) + X1 (t) + B1 (femme)
  },
  'ḥm': {
    translation: 'Mari / Homme',
    translationEn: 'Husband / Man',
    illustration: '𓍛𓀀' // U36 (ḥm) + A1
  },
  'tꜣy': {
    translation: 'Conjoint / Mâle',
    translationEn: 'Spouse / Male',
    illustration: '𓍿𓄿𓇋𓇋𓀀' // V13 (ṯ) + G1 (Ꜣ) + M17-M17 (y) + A1
  },
  'sꜣ': {
    translation: 'Enfant',
    translationEn: 'Child',
    illustration: '𓄟',
    leadSign: 'F31',
    leadSignNote: 'F31 a pour valeur réelle « ms » (naître), pas « sꜣ » — même signe que dans Ḏḥwty-ms « né de Thot » (Pharaons) et Msḫnt, déesse de la naissance (Divinités) : la fiche associe ici « enfant » au même signe-racine « naissance », plutôt qu\'au signe classique de sꜣ (l\'oison G38/G39).',
    reading: 'Lecture analytique — sꜣ, « enfant » (illustré ici par 𓄟, F31, dont la valeur phonétique établie est en réalité « ms », « naître » — voir la fiche « ms » à travers Ḏḥwty-ms dans Pharaons et Msḫnt dans Divinités — plutôt que le signe classique de sꜣ, l\'oison G38/G39, voir la fiche « gb » dans Animaux pour ce signe). Trois fiches (enfant, Thoutmosis « né de Thot », Meskhenet déesse de la naissance) convergent ainsi sur le même signe-racine « naissance », par-delà la différence de translittération.',
    readingEn: 'Analytical reading — sꜣ, "child" (illustrated here by 𓄟, F31, whose established phonetic value is actually "ms," "to be born" — see the "ms" entry through Ḏḥwty-ms in Pharaohs and Msḫnt in Divinities — rather than the classic sign for sꜣ, the gosling G38/G39; see the "gb" entry in Animals for that sign). Three entries (child, Thutmose "born of Thoth," Meskhenet goddess of birth) thus converge on the same root sign "birth," beyond the difference in transliteration.'
  },
  'sꜣ ḥm': {
    translation: 'Fils',
    translationEn: 'Son',
    illustration: '𓅭𓀀' // G39 (sꜣ) + A1 (ou F31 + A1 si vous gardez votre convention ms)
  },
  'sꜣt': {
    translation: 'Fille',
    translationEn: 'Daughter',
    illustration: '𓅭𓏏𓁐' // G39 (sꜣ) + X1 (t) + B1 (femme)
  },
  'sꜣ sꜣ': {
    translation: 'Petit-enfant',
    translationEn: 'Grandchild',
    illustration: '𓅭𓅭' // Deux oisons/canards
  },
  'sn ḥmt': {
    translation: 'Beau-frère (frère de l\'épouse)',
    translationEn: 'Brother-in-law (wife\'s brother)',
    illustration: '𓈖𓏌𓀀𓈞𓏏𓁐'
  },
  'snt ḥmt': {
    translation: 'Belle-sœur (sœur de l\'épouse)',
    translationEn: 'Sister-in-law (wife\'s sister)',
    illustration: '𓈖𓏌𓏏𓁐𓈞𓏏𓁐'
  },
  'ḥmt sn': {
    translation: 'Belle-sœur (femme du frère)',
    translationEn: 'Sister-in-law (brother\'s wife)',
    illustration: '𓈞𓏏𓁐𓈖𓏌𓀀'
  },
  'dmdyt': {
    translation: 'Rassemblement, réunion',
    translationEn: 'Gathering, assembly',
    illustration: '𓋧𓂧𓇋𓇋𓏏𓏛',
    leadSign: 'S23',
    leadSignNote: 'S23 (anneau-šen à deux fléaux), le même signe que dans dmd/dm : hausa jàma\'à, bamanan jàma « foule, assemblée ».',
    reading: 'Lecture analytique — dmdyt (S23-D46-M17-M17-X1-Y1), « rassemblement, réunion ». S23 (anneau-šen à deux fléaux) est le signe directeur : il porte le sens de « réunir » (à rapprocher de dmd, « réassembler un corps démembré », voir la fiche « dmd » dans Divinités, et de dm, « prononcer le nom », voir la fiche « dm » dans Verbes). D46, M17-M17, X1 et Y1 sont des compléments phonétiques et le déterminatif. Hausa jàma\'à, « foule, assemblée » — même champ lexical.',
    readingEn: 'Analytical reading — dmdyt (S23-D46-M17-M17-X1-Y1), "gathering, assembly." S23 (a shen-ring flanked by two flails) is the lead sign: it carries the meaning "to gather" (compare dmd, "to reassemble a dismembered body," see the "dmd" entry in Divinities, and dm, "to pronounce the name," see the "dm" entry in Verbs). D46, M17-M17, X1, and Y1 are phonetic complements and the determinative. Hausa jàma\'à, "crowd, assembly" — the same lexical field.'
  },
  'ḫ': {
    translation: 'Enfance, être dans l\'enfance',
    translationEn: 'Childhood, to be a child',
    illustration: '𓐍𓏺𓀔',
    leadSign: 'Aa1',
    leadSignNote: 'Aa1 (placenta) porte le son ḫ, mot indépendant : bamanan koyi « ergot » ; mandinka koyi « propre, innocent ».',
    reading: 'Lecture analytique — ḫ (Aa1-Z1-A17), « enfance, être dans l\'enfance ». Aa1 (placenta) est le signe directeur, porteur seul du son ḫ ; Z1 est un simple trait de complément ; A17 (enfant assis, doigt à la bouche) est le déterminatif. Mandinka koyi, « propre, innocent » — l\'innocence de l\'enfance retrouvée dans ce même radical.',
    readingEn: 'Analytical reading — ḫ (Aa1-Z1-A17), "childhood, to be a child." Aa1 (placenta) is the lead sign, alone carrying the sound ḫ; Z1 is a simple complement stroke; A17 (a seated child, finger to the mouth) is the determinative. Mandinka koyi, "clean, innocent" — the innocence of childhood found again in this same root.'
  },
  'ẖrd': {
    translation: 'Enfant, être ou devenir un enfant',
    translationEn: 'Child, to be or become a child',
    illustration: '𓄡𓂋𓂧𓀔',
    leadSign: 'F32',
    leadSignNote: 'F32 (ventre à mamelles, valeur ẖ) porte le mot ẖrd, « enfant » : téké ŋkere « enfant » ; yoruba kóró « noyau, pépin » — l\'enfant comme une graine.',
    reading: 'Lecture analytique — ẖrd (F32-D21-D46-A17), « enfant, être ou devenir un enfant ». F32 (ventre à mamelles) est le signe directeur, porteur du son ẖ ; D21 et D46 sont des compléments phonétiques ; A17 (enfant assis, doigt à la bouche) est le déterminatif — le même que dans ḫ, « enfance » (voir la fiche « ḫ » ci-dessus). Ce mot est aussi la racine de l\'épithète Ḥr-pꜣ-ẖrd, « Harpocrate, Horus l\'enfant » (voir la fiche « Ḥr-pꜣ-ẖrd » dans Divinités). Yoruba kóró, « noyau, pépin » — l\'enfant comme une graine.',
    readingEn: 'Analytical reading — ẖrd (F32-D21-D46-A17), "child, to be or become a child." F32 (a belly with teats) is the lead sign, carrying the sound ẖ; D21 and D46 are phonetic complements; A17 (a seated child, finger to the mouth) is the determinative — the same one as in ḫ, "childhood" (see the "ḫ" entry above). This word is also the root of the epithet Ḥr-pꜣ-ẖrd, "Harpocrates, Horus the Child" (see the "Ḥr-pꜣ-ẖrd" entry in Divinities). Yoruba kóró, "kernel, seed" — the child as a seed.'
  },
  'ẖdr': {
    translation: 'Enfants ; sauver, porter secours',
    translationEn: 'Children; to save, help',
    illustration: '𓄡𓂧𓂋𓅪',
    leadSign: 'F32',
    leadSignNote: 'F32 (ventre à mamelles, valeur ẖ) porte aussi ẖdr, « enfants ; sauver » : malinké kɔ́re « descendance » ; fang kôré « délivrer, sauver ».',
    reading: 'Lecture analytique — ẖdr (F32-D46-D21-G37), « enfants » (une seconde graphie, F32-D46-D21-D36, donne « sauver, porter secours » — même racine, sens voisin). F32 (ventre à mamelles) est le signe directeur, porteur du son ẖ ; D46 et D21 sont des compléments phonétiques ; G37 (moineau, petit) est le déterminatif de cette graphie. Rejoint par le sens ẖrd, « enfant » (voir la fiche « ẖrd » ci-dessus). Fang kôré, « délivrer, sauver » — même radical que le sens « secourir » de ẖdr.',
    readingEn: 'Analytical reading — ẖdr (F32-D46-D21-G37), "children" (a second spelling, F32-D46-D21-D36, gives "to save, to help" — the same root, a related meaning). F32 (a belly with teats) is the lead sign, carrying the sound ẖ; D46 and D21 are phonetic complements; G37 (sparrow, small) is the determinative for this spelling. Connected in meaning with ẖrd, "child" (see the "ẖrd" entry above). Fang kôré, "to deliver, to save" — the same root as the "to help" sense of ẖdr.'
  },
};

export default famille;
export {};
